
import { InjectedIntl } from 'react-intl';
import { FormSelectChoice, VerificationStep, VerificationStepsEnum } from '@sheerid/jslib';

import { SoftwareType, CourseType } from './types/types';
import { CourseTypesEnum, SoftwareTypesEnum } from './types/runtimeTypes';
import { assertValidSoftwareType } from './types/assertions';
import { QUICKBOOKS_ONLINE_DOC_UPLOAD_CLICK_TRACKING, PRO_CONNECT_DOC_UPLOAD_CLICK_TRACKING, QUICKBOOKS_ONLINE_COLLECT_INFO_CLICK_TRACKING, PRO_CONNECT_COLLECT_INFO_CLICK_TRACKING } from '../constants';

export const mapSoftwareTypeToHumanReadable = (softwareType: SoftwareType, intl: InjectedIntl) => {

    try {
        assertValidSoftwareType(softwareType);
    } catch {
        return undefined;
    }

    const humanReadable = intl.formatMessage({
        id: `softwareTypes.${softwareType}`,
        defaultMessage: `${softwareType}`,
    });

    return humanReadable;
};

export const getCourseTypeChoices = (intl: InjectedIntl): FormSelectChoice<CourseType, string>[] => {
    const courseTypes: FormSelectChoice<CourseType, string>[] = [];

    Object.values(CourseTypesEnum).map(courseType => courseTypes.push({
        value: courseType as CourseType,
        label: intl.formatMessage({ id: `${courseType.toLowerCase()}`, defaultMessage: `${courseType}` }),
    }));
    return courseTypes;
};

export const getClickTrackingMessage = (step: VerificationStep, softwareType: SoftwareType) => {
    let clickTrackingMessage;

    if (step === VerificationStepsEnum.collectStudentPersonalInfo) {
        switch (softwareType) {
            case SoftwareTypesEnum.ONLINE:
                clickTrackingMessage = QUICKBOOKS_ONLINE_COLLECT_INFO_CLICK_TRACKING;
                break;
            case SoftwareTypesEnum.TAX:
                clickTrackingMessage = PRO_CONNECT_COLLECT_INFO_CLICK_TRACKING;
                break;
            default:
                break;
        }
    } else if (step === VerificationStepsEnum.docUpload) {
        switch (softwareType) {
            case SoftwareTypesEnum.ONLINE:
                clickTrackingMessage = QUICKBOOKS_ONLINE_DOC_UPLOAD_CLICK_TRACKING;
                break;
            case SoftwareTypesEnum.TAX:
                clickTrackingMessage = PRO_CONNECT_DOC_UPLOAD_CLICK_TRACKING;
                break;
            default:
                break;
        }
    }

    return clickTrackingMessage;
};
